export default __webpack_public_path__ + "static/stairs-6bad3755cf05aa937a8e5abf699803bd.gif";